import { render } from "./Wall.vue?vue&type=template&id=2c29e8bb&scoped=true"
import script from "./Wall.vue?vue&type=script&lang=js"
export * from "./Wall.vue?vue&type=script&lang=js"

import "./Wall.vue?vue&type=style&index=0&id=2c29e8bb&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c29e8bb"]])

export default __exports__